// extracted by mini-css-extract-plugin
module.exports = {"comp":"Dialog1_comp__yBsa8"};